@if (data(); as _data) {
  <div class="attributes">
    <div class="field">
      <span class="label">Art.Nr.</span>
      <span class="value">{{ _data.articleNumber }}</span>
    </div>

    @if (_data.ean?.article; as ean) {
      <div class="field">
        <span class="label">EAN</span>
        <span class="value">{{ ean }}</span>
      </div>
    }

    @if (_data.ean?.packaging; as eanPackaging) {
      <div class="field">
        <span class="label">Stangen-EAN</span>
        <span class="value">{{ eanPackaging }}</span>
      </div>
    }

    @if (_data.articleNumberStable; as articleNumberStable) {
      <div class="field">
        <span class="label">Stab. Art.-Nr.</span>
        <span class="value">{{ articleNumberStable }}</span>
      </div>
    }

    <div class="field">
      <span class="label">VE</span>
      <span class="value">{{ _data.packagingUnit }}</span>
    </div>

    @if (_data.durability; as durability) {
      <div class="field">
        <span class="label">Mind. Restlaufzeit</span>
        <span class="value">{{ durability }}</span>
      </div>
    }

    @if (_data.convenienceLevel; as convenienceLevel) {
      <div class="field">
        <span class="label">Conveniencegrad</span>
        <span class="value">{{ convenienceLevel }}</span>
      </div>
    }
  </div>

  @if (showProductInformationOnly() && _data.LMiVDocumentLink) {
    <ui-button
      class="download-button"
      buttonStyle="outlined"
      (clicked)="openLMiVDocument(_data.LMiVDocumentLink)"
    >
      LMIV Produktdatenblatt herunterladen
    </ui-button>
  } @else {
    <a class="info-link" (click)="scrollToProductInfo()">Weitere Informationen zum Produkt</a>
  }
}
